import { NodeType } from '@amplify/amp-module';
import formStore from './form-store';
import InsightsNodeHandler from '../insights-node-handler';

export default class FormHandler extends InsightsNodeHandler {
  constructor(ctx) {
    super(ctx, NodeType.form);

    if (!formStore.registered) {
      this.store.registerModule('formStore', formStore);
      formStore.registered = true;
    }
  }

  async handleNode(node, options = {}) {
    await super.handleNode(node, { ...options, handleStorage: false });

    this.store.dispatch('formStore/setFormOpen', { state: true });
    this.trackResponseEvent('form', {
      formId: node.id,
      stateType: 'OPEN',
    });

    this.unwatchSubmit = this.store.watch(
      (state) => state.formStore.formSubmitted,
      (formSubmitted) => {
        if (!formSubmitted) return;
        this.unwatchSubmit();

        if (node.storage) {
          this.store.dispatch('chatbotStore/addToStorage', { key: node.storage, data: formSubmitted });
        }

        const { formData } = this.store.state.formStore;

        node.fields?.forEach((field) => {
          if (field.storageKey) {
            const storageKey = this.store.getters['chatbotStore/getStorageId'](field.storageKey);
            if (storageKey) {
              this.store.dispatch('chatbotStore/addToStorage', { key: storageKey, data: formData[field.id] });
            }
          }
        });
      },
    );

    const result = new Promise((resolve) => {
      this.unwatch = this.store.watch(
        (state) => state.formStore.formOpen,
        (formOpen) => {
          if (formOpen) return;
          this.unwatch();

          this.store.dispatch('formStore/setFormData', {});
          this.store.dispatch('formStore/setReturnToConversationClicked', false);
          this.store.dispatch('formStore/resetForm');

          resolve(this.store.getters['chatbotStore/nextNode'](node.id));
        }
      );
    });

    return result;
  }
}
